module.exports = __webpack_public_path__ + "assets/webgl/card_080_EN_L0.bd691516.jpg";